import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Briefcase, Building2 } from "lucide-react";
import { NeuCard } from "../../components/neu/Neu";
import { myDutiesToday } from "../../api/duties";
import { useFeatures } from "../../hooks/useFeatures";

// Employee home: pick today's duty so the check-in fence follows the mission location.
export const MyDutyCard = ({ dutyId, onSelect }) => {
  const { t } = useTranslation();
  const features = useFeatures();
  const [duties, setDuties] = useState([]);

  useEffect(() => {
    if (!features.duties) return;
    myDutiesToday().then(setDuties).catch(() => setDuties([]));
  }, [features.duties]);

  if (!features.duties || duties.length === 0) return null;

  return (
    <NeuCard className="animate-rise-in p-4" data-testid="my-duty-card">
      <p className="label-xs flex items-center gap-2 text-sm">
        <Briefcase className="h-4 w-4 text-primary" /> {t("duty.todayTitle")}
      </p>
      <p className="mt-1 text-sm text-muted-foreground">{t("duty.todayHint")}</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <Chip active={!dutyId} testId="duty-pick-branch" onClick={() => onSelect("")} icon={Building2} label={t("duty.useBranch")} />
        {duties.map((d) => (
          <Chip
            key={d.id}
            active={dutyId === d.id}
            testId={`duty-pick-${d.id}`}
            onClick={() => onSelect(d.id)}
            icon={Briefcase}
            label={`${d.title}${d.start_time ? ` · ${d.start_time}` : ""}`}
          />
        ))}
      </div>
    </NeuCard>
  );
};

const Chip = ({ active, onClick, label, testId, icon: Icon }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={onClick}
    className={`flex items-center gap-1.5 rounded-full border px-3 py-2 text-sm font-bold transition-[box-shadow,color] duration-300 ${
      active ? "border-primary/50 text-primary shadow-neu-in" : "border-border/60 text-muted-foreground shadow-neu-sm"
    }`}
  >
    <Icon className="h-3.5 w-3.5" />
    <span className="max-w-[12rem] truncate">{label}</span>
  </button>
);
